import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTheme } from '@mui/material/styles';
import CustomButton from "../../components/CustomButton";
import { makeStyles } from '@mui/styles';
import { CardGiftcard, CheckBoxOutlineBlank, CheckBoxOutlineBlankOutlined, CheckBoxOutlined, CheckCircleOutline, CheckCircleOutlineRounded, CheckCircleOutlined, CheckCircleRounded, CreditCard, DateRangeOutlined, LockClockOutlined, PaymentsOutlined, ReceiptLongOutlined, ReceiptOutlined, ShoppingCart, ShoppingCartCheckoutOutlined } from "@mui/icons-material";
import { portalCfg } from "../../config";
import { PackageIcon } from "../../components/CustomIcons";
import StepHeader from "../../components/StepHeader";
import { getPackageInfo, isVumaPackage } from "../../utils/commons";
import { cached } from "../../utils/cache";
import { STEPS_REGISTER } from "../../utils/util";
import { useTranslation } from "react-i18next";
import CustomCircularProgress from "../../components/CustomCircularProgress";

const useStyles = makeStyles((theme) => ({
    select_container: {
        width: '100%',
        marginTop: theme.spacing(2),
        border: '2px solid ' + theme.palette.primary.main,
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    select_input: {
        border: 0,
    },
    option_payment: {
        width: '100%',
        cursor: 'pointer',
        padding: theme.spacing(2, 4),
        margin: theme.spacing(2, 0),
        borderRadius: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            width: '100%',
            padding: theme.spacing(1),
        },
    },
    paperSm: {
        width: 600,
        borderRadius: theme.spacing(2),
    },
    title: {
        borderBottom: '1px solid ' + theme.palette.background.primary,
        paddingBottom: theme.spacing(1),
    },
}))

export default function PlaceOrderView(props) {
    const { isAcceptTC, setIsAcceptTC, billingInfo, packageInfo } = props;
    const { palette, spacing } = useTheme();
    const classes = useStyles();
    const { t } = useTranslation();
    const onGoBack = () => {
        if (packageInfo && isVumaPackage(packageInfo.product_type)) {
            props.stepsControl.goToStepByName(STEPS_REGISTER.payment);
        } else {
            props.stepsControl.goToStepByName(STEPS_REGISTER.billing_date);
        }
    }
    return (
        <Grid item xs={12} container justifyContent={'center'} sx={{ paddingX: { xs: 2, md: 4 }}}>
            <StepHeader
                title={t('review_and_place_order')}
                palette={palette}
                onBack={() => onGoBack()}
            />
            <Grid item xs={12} sm={6} bgcolor={palette.common.white} borderRadius={spacing(3)} sx={{ padding: { xs: 0, md: 2 } }}>
                <Grid item xs={12} my={2}>
                    <Grid item xs={12} my={2} padding={spacing(2)} border={`2px solid ${palette.primary.main}`} borderRadius={spacing(2)}>
                        <Grid item xs={12} pb={1} borderBottom={`1px solid ${palette.primary.main}`}>
                            <Typography variant="h6">{t('order_summary')}</Typography>
                        </Grid>
                        <Grid item xs={12} pb={2} borderBottom={`1px solid ${palette.primary.main}`}>
                            <Grid item xs={12} container spacing={1} my={1}>
                                <Grid item>
                                    <ShoppingCartCheckoutOutlined />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2" fontWeight={'bold'}>Package</Typography>
                                    <Typography>{packageInfo?.family?.name || packageInfo?.family} {packageInfo?.name}</Typography>
                                </Grid>
                            </Grid>
                            {billingInfo?.date && <Grid item xs={12} container spacing={1} my={1}>
                                <Grid item>
                                    <DateRangeOutlined />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2" fontWeight={'bold'}>{t('billing_date')}</Typography>
                                    <Typography>{mappingBillingDate(billingInfo?.date)} {t('of_the_month')}</Typography>
                                </Grid>
                            </Grid>}
                            <Grid item xs={12} container spacing={1} my={1}>
                                <Grid item>
                                    <CreditCard />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2" fontWeight={'bold'}>{t('payment_method')}</Typography>
                                    {billingInfo?.option_payment == 'PAYGATE' && <img src={`${portalCfg.publicPath}/images/paygate.png`} height={30} />}
                                    {billingInfo?.option_payment == 'EASYPAY' && <img src={`${portalCfg.publicPath}/images/easypay.png`} height={30} />}
                                    <Typography>{t('pay_secure_paygate')} {billingInfo?.option_payment?.toLowerCase()}</Typography>
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={12} container spacing={1} my={1}>
                                <Grid item>
                                    <DateRangeOutlined />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2" fontWeight={'bold'}>First payment</Typography>
                                    <Typography>Billed on May 1, 2024</Typography>
                                </Grid>
                            </Grid> */}
                            <Grid item xs={12} container spacing={1} my={1}>
                                <Grid item>
                                    <PaymentsOutlined />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2" fontWeight={'bold'}>{t('monthly_total')}</Typography>
                                    <Typography>R{packageInfo?.price?.toFixed(2) || (packageInfo?.pricing?.price ? parseFloat(packageInfo.pricing.price).toFixed(2) : '')} {t('order_per_month')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} py={2}>
                            <Grid item xs={12} container spacing={1}>
                                <Grid item>
                                    <LockClockOutlined />
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" fontWeight={'bold'}>{t('payments_secure_encrypted')}</Typography>
                                    <Typography>{t('confirmation_sms_email')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} my={2}>
                    <Grid item xs={12} container spacing={1} onClick={() => setIsAcceptTC(!isAcceptTC)} style={{ cursor: 'pointer' }}>
                        <Grid item>
                            {isAcceptTC ? <CheckBoxOutlined style={{ color: palette.primary.main }} /> : <CheckBoxOutlineBlank style={{ color: palette.primary.main }} />}
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle1" fontWeight={'bold'}>{t('accept_terms_conditions')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} my={2} mt={4} container justifyContent={'center'}>
                    <CustomButton disabled={!isAcceptTC} variant={'contained'} onClick={() => props.onPlaceOrder()}>{t('place_order')}</CustomButton>
                </Grid>
            </Grid>
            <Dialog
                open={props.openContactExistsDialog}
                onClose={() => { props.setOpenContactExistsDialog(false) }}
                maxWidth={'sm'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{
                    paper: classes.paperSm,
                }}
            >
                <DialogTitle id="alert-dialog-title" className={classes.title}>
                    <Typography variant="h6" color={palette.primary.main}>{t('CONTACT_ALREADY_EXIST')}</Typography>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <Typography variant="subtitle" my={2}>{t('PLEASE_VERIFY_OTP')}</Typography>
                    <TextField
                        fullWidth
                        value={props.tempEmail}
                        onChange={(e) => props.setTempEmail(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        disabled
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleCancelDialog} color="primary">
                        {t('btn_cancel')}
                    </Button>
                    <Button onClick={props.handleVerifyOtp} color="primary" variant="contained">
                        {props.loadingOtp ? <CustomCircularProgress /> : <>{t('VERIFY_OTP')}</>}
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
function mappingBillingDate(date) {
    if (date == '1') return '1st';
    if (date == '2') return '2nd';
    if (date == '16') return '16th';
    if (date == '21') return '21st';
    if (date == '26') return '26th';
}